import React from 'react';
import { useRouter } from 'next/router';
import Image from 'next/legacy/image';
import { ProductOwner, PurchaseRentMeeting } from 'types';
import { formatDateAgo } from '../../utils/formatters';
import { Button } from 'components/Button';
import { NextLink } from 'components/NextLink';
import { NextIcon } from 'components/NextImage';

import styles from './ProductPage.module.scss';
import { USER_PHOTO_PLACEHOLDER_LINK } from '../../consts';

export type PageAuthorInfoProps = {
  gearId: string;
  isAdmin?: boolean;
  isOwner?: boolean;
  isAuth: boolean;
  meeting?: PurchaseRentMeeting;
  postedAt: number;
  productOwner: ProductOwner;
  redirectToAuth: () => void;
  isRent?: boolean;
};

export const PageOwnerInfo = ({
  gearId,
  isAdmin,
  isAuth,
  isOwner,
  meeting,
  postedAt,
  productOwner,
  redirectToAuth,
  isRent,
}: PageAuthorInfoProps) => {
  const router = useRouter();

  const openGearChat = () => {
    router.push(`/messages/rooms/items/${gearId}`);
  };

  return (
    <div className={styles.ownerInfo}>
      <div className={styles.ownerContent}>
        <NextLink href={`/users/${productOwner.username}`}>
          <div className={styles.ownerInfoAvatar}>
            <Image src={productOwner.photo || USER_PHOTO_PLACEHOLDER_LINK} layout="fill" objectFit="cover" alt={productOwner.username} />
          </div>
        </NextLink>
        <div className={styles.ownerInfoTexting}>
          <p>
            <span>{productOwner.username}</span>
          </p>
          {isRent && (
            <div className={styles.address}>
              <NextIcon src="/icons/maps/MapPinGray.svg" width={16} />
              <p>{`${meeting?.city || productOwner.city},`}</p>
              <p>{meeting?.state || productOwner.state}</p>
              {(meeting?.country || productOwner.country) === 'CA' ||
                ((meeting?.country || productOwner.country) === 'CAN' &&
                  <NextIcon src="/icons/Maple.svg" width={20} />)}
            </div>
          )}
        </div>
      </div>
      {!isOwner && !isAdmin && (
        <Button
          caption="Send Message to Seller"
          action={isAuth ? openGearChat : redirectToAuth}
          buttonType="whiteBlack"
          iconSrc="/icons/communications/EnvelopeSimpleDark.svg"
          fit={false}
        />
      )}
    </div>
  );
};
